import logo from "@/assets/logo.png";
import mark from "@/assets/mark.png";
import heroWheel from "@/assets/real/hero_wheel.jpg";
import imgWheel from "@/assets/real/wheel.jpg";
import imgWheelAction from "@/assets/real/wheel_action.jpg";
import imgWheelchair from "@/assets/real/wheelchair.jpg";
import imgWheelchair2 from "@/assets/real/wheelchair2.jpg";
import imgGate from "@/assets/real/gate.jpg";
import imgGate2 from "@/assets/real/gate2.jpg";
import imgExhaust from "@/assets/real/exhaust.jpg";
import imgPipe from "@/assets/real/pipe.jpg";
import imgWeldBead from "@/assets/real/weld_bead.jpg";
import imgAbout from "@/assets/real/about.jpg";
import videoPoster from "@/assets/real/video_poster.jpg";
import contactBg from "@/assets/real/contact_bg.jpg";
// NOTE: real2 file names don't match contents (uploads arrived scrambled).
// Variables are named by what each photo ACTUALLY shows (verified with the owner).
import imgBulletAfter from "@/assets/real2/tig_detail.jpg"; // maroon sedan — bullet hole AFTER repair
import imgBulletBefore from "@/assets/real2/firetruck_repair.jpg"; // maroon sedan — BEFORE, mobile setup on-site
import imgFtHose from "@/assets/real2/bullet1.jpg"; // fire truck hose assembly, TIG welded
import imgFtHoseDetail from "@/assets/real2/bullet2.jpg"; // fire truck hose assembly TIG bead close-up
import imgFtPipe from "@/assets/real2/firetruck_pipe.jpg"; // long stainless fire truck pipe assembly
import imgExhaustDetail from "@/assets/real2/montecarlo.jpg"; // custom exhaust TIG weld close-up
import imgFlowers from "@/assets/real2/newB.jpg"; // metal flowers
import imgMonte from "@/assets/real2/newC.jpg"; // white Monte Carlo SS on the lift

export { logo, mark, imgAbout, contactBg };
export const hero = heroWheel;

export const BUSINESS = {
  name: "Deuce's",
  tagline: "Built Strong. Built Right.",
  phone: "404-919-4067",
  phoneHref: "tel:+14049194067",
  smsHref: "sms:+14049194067",
  email: "ata.hassan.re@proton.me",
  emailHref: "mailto:ata.hassan.re@proton.me",
  area: "Atlanta & Surrounding Communities",
  hours: "Mon–Sat: 7am – 7pm · Emergency service available",
  bookUrl:
    "https://app.squareup.com/appointments/book/4kwkpjt621y0um/L0DP1RYQ2R73Q/start",
  depositUrl: "https://square.link/u/3jiThe7K",
};

// Real welding clip (transcoded to web MP4) with a generated poster frame.
export const HERO_VIDEO = { src: "/media/welding.mp4", poster: videoPoster };

export const NAV_LINKS = [
  { label: "Home", to: "home" },
  { label: "About", to: "about" },
  { label: "Services", to: "services" },
  { label: "Projects", to: "projects" },
  { label: "Gallery", to: "gallery" },
  { label: "Reviews", to: "reviews" },
  { label: "Contact", to: "contact" },
];

export const SERVICES = [
  { icon: "Flame", title: "Mobile Welding", text: "On-site welding brought straight to your location." },
  { icon: "Car", title: "Automotive Welding", text: "Repairs and fabrication for cars, trucks and trailers." },
  { icon: "CircleDot", title: "Wheel Repair", text: "Aluminum & alloy wheel crack and gouge repair." },
  { icon: "DoorOpen", title: "Gate Repair", text: "Steel gate alignment, strength and durability repairs." },
  { icon: "Caravan", title: "Trailer Repair", text: "Frames, hitches, ramps and structural trailer work." },
  { icon: "Wrench", title: "Equipment Repair", text: "Heavy equipment and machinery weld repairs." },
  { icon: "Building2", title: "Steel Fabrication", text: "Custom steel builds fabricated to your specs." },
  { icon: "Sparkles", title: "Aluminum Welding", text: "Clean, strong aluminum TIG & MIG welds." },
  { icon: "Layers", title: "Stainless Welding", text: "Precision stainless steel TIG welding." },
  { icon: "Siren", title: "Emergency Welding", text: "Urgent repairs when you can't afford downtime." },
  { icon: "Hammer", title: "Custom Fabrication", text: "One-off metal work, brackets and builds." },
  { icon: "Home", title: "Residential Welding", text: "Railings, fences, gates and home repairs." },
  { icon: "Factory", title: "Commercial Welding", text: "Reliable welding for businesses & property managers." },
  { icon: "MapPin", title: "On-Site Welding", text: "We bring the shop to your job site." },
  { icon: "Settings", title: "General Repairs", text: "If it's metal and it's broken, we can fix it." },
];

export const SPOTLIGHT = {
  eyebrow: "Project of the Month",
  title: "Automotive Bullet Hole Repair",
  before: imgBulletBefore,
  after: imgBulletAfter,
  description:
    "A sedan took a bullet hole straight through the body — we brought the shop to the car and repaired it on-site with our mobile welding setup, no trip to a body shop needed. Drag the slider to compare before and after.",
  problem:
    "A bullet hole punched through the car's body and damaged the surrounding metal — the owner needed it welded and repaired where the car sat.",
  details: [
    "Mobile repair — welded on-site at the car",
    "Bullet hole welded closed, metal worked back",
    "Weld beads laid clean and controlled",
    "Prepped and ready for bodywork & paint",
  ],
};

export const PROJECTS = [
  {
    id: "bullet-hole",
    title: "Automotive Bullet Hole Repair",
    image: imgBulletAfter,
    gallery: [imgBulletAfter, imgBulletBefore],
    category: "Automotive Repair",
    services: ["Automotive Welding", "Mobile Welding"],
    materials: "Vehicle body metal",
    repairType: "Bullet hole repair — before & after",
    process: "Mobile on-site welding",
    short: "Bullet hole through a sedan's body, welded and repaired on-site.",
    description:
      "This sedan took a bullet hole through the body. We brought the shop to the car — welded the hole closed on-site with our mobile setup, laid clean controlled beads, and prepped the area so it's ready for bodywork and paint.",
  },
  {
    id: "monte-carlo",
    title: "Monte Carlo SS Frame Notch",
    image: imgMonte,
    gallery: [imgMonte],
    category: "Automotive Fabrication",
    services: ["Automotive Fabrication", "Custom Metal Work"],
    materials: "G-Body chassis steel",
    repairType: "Custom fabrication",
    process: "Custom cutting & welding",
    short: "Custom automotive fabrication on a Dale Earnhardt Edition Monte Carlo SS.",
    description:
      "Custom automotive fabrication on a Monte Carlo SS / G-Body — cutting and welding custom metal work to suit the build.",
  },
  {
    id: "firetruck-tig",
    title: "Fire Truck Hose Assembly",
    image: imgFtHose,
    gallery: [imgFtHose, imgFtHoseDetail, imgFtPipe],
    category: "TIG Welding",
    services: ["TIG Welding", "Stainless Steel Work"],
    materials: "Stainless steel",
    repairType: "Hose assembly TIG weld",
    process: "Precision TIG welding",
    short: "Fire truck hose assembly, TIG welded on stainless steel.",
    description:
      "A fire truck hose assembly TIG welded — clean, controlled beads on stainless, with the full pipe assembly fitted and finished.",
  },
  {
    id: "wheel-repair",
    title: "Aluminum Wheel Repair",
    image: imgWheel,
    gallery: [imgWheel, imgWheelAction, imgWeldBead],
    category: "Automotive Repair",
    services: ["Automotive Welding", "TIG Welding"],
    materials: "Aluminum alloy wheel",
    repairType: "Wheel weld repair",
    process: "TIG welding",
    short: "Damaged aluminum wheel welded and dressed back smooth.",
    description:
      "An aluminum alloy wheel repaired with TIG welding — damage filled, welded and dressed back toward a smooth finish.",
  },
  {
    id: "exhaust",
    title: "Custom Exhaust Fabrication",
    image: imgPipe,
    gallery: [imgPipe, imgExhaustDetail, imgExhaust],
    category: "Exhaust Work",
    services: ["Exhaust Fabrication", "TIG Welding"],
    materials: "Stainless steel exhaust tubing",
    repairType: "Custom exhaust build",
    process: "TIG welding",
    short: "Custom stainless exhaust system, TIG welded and finished.",
    description:
      "Custom exhaust work in stainless steel — sections measured, fitted and TIG welded with clean, consistent beads for a durable finished system.",
  },
  {
    id: "wheelchair",
    title: "Wheelchair Frame Repair",
    image: imgWheelchair,
    gallery: [imgWheelchair, imgWheelchair2],
    category: "Repairs",
    services: ["Metal Repair", "Welding"],
    materials: "Wheelchair frame",
    repairType: "Frame repair",
    process: "Welding",
    short: "Wheelchair frame repaired and back in service.",
    description:
      "A wheelchair frame torn down, welded and repaired so it's back in service.",
  },
  {
    id: "gate",
    title: "Gate Welding — On-Site",
    image: imgGate,
    gallery: [imgGate, imgGate2],
    category: "Repairs",
    services: ["Mobile Welding", "Metal Repair"],
    materials: "Steel gate & fencing",
    repairType: "On-site weld repair",
    process: "Mobile welding",
    short: "Steel gate welded on-site, fixed where it stands.",
    description:
      "On-site welding on a steel gate — repaired where it stands with the mobile setup.",
  },
  {
    id: "metal-flowers",
    title: "Metal Flowers",
    image: imgFlowers,
    gallery: [imgFlowers],
    category: "Metal Art",
    services: ["Metal Art", "Creative Fabrication"],
    materials: "Steel nuts & rod",
    repairType: "Creative metal art",
    process: "Welded fabrication",
    short: "A creative metalworking piece — flowers fabricated from steel hardware.",
    description:
      "A creative metalworking project — flowers fabricated from nuts and steel, showcasing custom artistic welding.",
  },
];

export const GALLERY = [
  { image: imgBulletAfter, title: "Bullet Hole Repair — After", category: "Automotive Repair", alt: "Maroon sedan door after bullet hole weld repair" },
  { image: imgBulletBefore, title: "Bullet Hole Repair — Before", category: "Automotive Repair", alt: "Maroon sedan before repair, mobile welding machine set up on-site" },
  { image: imgFtHose, title: "Fire Truck Hose Assembly", category: "TIG Welding", alt: "Fire truck hose assembly TIG welded" },
  { image: imgFtHoseDetail, title: "Hose Assembly TIG Detail", category: "TIG Welding", alt: "Close-up of TIG weld beads on the fire truck hose assembly" },
  { image: imgFtPipe, title: "Fire Truck Pipe Assembly", category: "TIG Welding", alt: "Long stainless steel fire truck pipe assembly removed for repair" },
  { image: imgExhaustDetail, title: "Custom Exhaust TIG Detail", category: "Exhaust Work", alt: "Close-up TIG weld on the custom exhaust" },
  { image: imgPipe, title: "Custom Exhaust System", category: "Exhaust Work", alt: "Polished stainless steel custom exhaust system after fabrication" },
  { image: imgExhaust, title: "Exhaust Fabrication", category: "Exhaust Work", alt: "Exhaust pipe being prepped for welding at a job site" },
  { image: imgMonte, title: "Monte Carlo SS Fabrication", category: "Automotive Fabrication", alt: "White Monte Carlo SS Dale Earnhardt Edition on a lift for custom fabrication" },
  { image: imgWheel, title: "Aluminum Wheel Repair", category: "Automotive Repair", alt: "Aluminum wheel rim with weld repairs dressed smooth" },
  { image: imgWheelAction, title: "Welding an Alloy Wheel", category: "Automotive Repair", alt: "Welding an alloy wheel on the workbench" },
  { image: imgWeldBead, title: "Wheel Weld Detail", category: "Automotive Repair", alt: "Close-up of a weld bead on the repaired wheel" },
  { image: imgWheelchair, title: "Wheelchair Frame Repair", category: "Repairs", alt: "Wheelchair frame welded and repaired" },
  { image: imgWheelchair2, title: "Wheelchair Teardown", category: "Repairs", alt: "Wheelchair frame torn down on the workbench for repair" },
  { image: imgGate, title: "Gate Welding — On-Site", category: "Repairs", alt: "Welding a steel gate on-site" },
  { image: imgGate2, title: "Gate Weld Repair", category: "Repairs", alt: "Mobile weld repair on a steel gate and fence" },
  { image: imgFlowers, title: "Metal Flowers", category: "Metal Art", alt: "Flowers fabricated from steel nuts as metal art" },
];

export const GALLERY_FILTERS = ["All", "Automotive Repair", "Automotive Fabrication", "TIG Welding", "Exhaust Work", "Repairs", "Metal Art"];

export const CAPABILITIES = [
  "Mobile Welding",
  "Automotive Welding & Repair",
  "Automotive Fabrication",
  "TIG Welding",
  "Stainless Steel Work",
  "Exhaust Repair & Fabrication",
  "Mild Steel Welding",
  "Aluminum Welding",
  "Custom Metal Projects",
  "Metal Art & Creative Fabrication",
];

export const ABOUT = {
  image: imgAbout,
  alt: "Deuce prepping stainless pipework at a mobile job site",
  heading: "Real Welders. Real Craftsmanship.",
  body: [
    "Deuce's is a mobile welding and fabrication operation built on doing the job right the first time. From automotive wheel repair to structural steel and custom builds, every weld is laid with precision and pride.",
    "We bring professional-grade equipment directly to you across metro Atlanta — fast, reliable, and finished to a standard we're proud to put our name on.",
  ],
  points: [
    "Quality workmanship",
    "Attention to detail",
    "Mobile welding",
    "Reliable repairs",
    "Professional service",
  ],
};

export const FEATURES = [
  { icon: "Truck", title: "Mobile Service", text: "We bring the shop to you across metro Atlanta." },
  { icon: "Zap", title: "Fast Response", text: "Quick turnaround and same-day availability." },
  { icon: "ReceiptText", title: "Free Estimates", text: "No-obligation quotes on every project." },
  { icon: "Wrench", title: "Professional Equipment", text: "Commercial-grade TIG, MIG and cutting tools." },
  { icon: "BadgeCheck", title: "Quality Workmanship", text: "Clean, strong welds we're proud to sign." },
  { icon: "CalendarCheck", title: "Reliable Scheduling", text: "We show up on time, every time." },
  { icon: "CreditCard", title: "Square Secure Payments", text: "Book & pay deposits securely online." },
];

export const MANIFESTO = [
  { no: "01", title: "Precision", text: "Every cut measured twice, every bead laid once. Nothing leaves our hands that we wouldn't stake our name on." },
  { no: "02", title: "Strength", text: "Structural integrity first. We build for the load, the road, and the years of hard use that follow." },
  { no: "03", title: "Reliability", text: "We show up, we finish, and we stand behind the work. Mobile, responsive, and accountable." },
];

export const REVIEWS = [
  { name: "Marcus T.", role: "Trailer Owner", text: "Deuce showed up fast and fixed my trailer hitch on-site. Clean welds, fair price. Highly recommend." },
  { name: "Latoya R.", role: "Homeowner", text: "Gate repair came out better than I imagined. True craftsmanship the whole way." },
  { name: "James P.", role: "Contractor", text: "Called for an emergency repair and he saved my project. Mobile welding done right." },
  { name: "Andrea K.", role: "Car Owner", text: "Aluminum wheel repair was flawless — strong and looks factory. Will use again." },
  { name: "Devon M.", role: "Customer", text: "Booked online, paid deposit through Square, easy process. Great work." },
  { name: "Priya S.", role: "Property Manager", text: "Reliable, on time, and quality work every time we call." },
];

export const WARRANTY = {
  title: "90-Day Workmanship Warranty",
  intro:
    "Deuce's warrants workmanship for ninety (90) days from the date of service. This warranty covers defects resulting from the quality of welding or fabrication performed by Deuce's.",
  notCovered: [
    "Misuse", "Abuse", "Accidents", "Corrosion", "Normal wear",
    "Improper maintenance", "Alterations", "Acts of Nature",
    "Natural disasters", "Vehicle accidents", "Third-party modifications",
    "Materials supplied by the customer", "Work performed by others",
  ],
};

export const FAQ = [
  { q: "Do you offer mobile welding?", a: "Yes. We're a fully mobile operation and bring our equipment directly to your location throughout metro Atlanta." },
  { q: "Can you repair aluminum?", a: "Absolutely. Aluminum TIG welding — including wheel repair — is one of our specialties." },
  { q: "Do you weld stainless steel?", a: "Yes, we offer precision stainless steel TIG welding for automotive, marine and fabrication work." },
  { q: "Do you repair trailers?", a: "Yes — frames, hitches, ramps, axles and structural trailer repairs." },
  { q: "How do quotes work?", a: "Send us photos and details through the quote form and we'll respond fast with a free estimate. Scheduled jobs may require a Square deposit." },
  { q: "What areas do you service?", a: "We serve Atlanta and surrounding communities within roughly a 50-mile radius." },
];
